<template>
  <div class="footer-box">
    <div class="footer-information min-width">
      <div class="footer-left">
        <img
          class="footer-logo"
          src="../../assets/images/new/logo.png"
          alt=""
        />
        <div class="footer-title">广西华之茂投资集团有限公司</div>
        <div class="footer-left-text">
          <div>集团地址</div>
          <div>贺州市八步区松木岭路122号7栋02号房 542800</div>
        </div>
        <!-- <div class="footer-left-text">
          <div>厂区地址</div>
          <div>江苏省无锡市滨湖区陆藕路17号 214161</div>
        </div> -->
      </div>
      <div class="footer-mid">
        <div class="mid-item" @click="toPage(item.appCode)" v-for="(item, index) in midList" :key="index">
          {{ item.name }}
        </div>
      </div>
      <div class="footer-right">
        <div class="footer-right-text">
          <div class="narrow">电 话</div>
          <div>0774-2522725</div>
        </div>
        <div class="footer-right-text">
          <div class="narrow">邮 箱</div>
          <div>654817953@qq.com</div>
        </div>
        <!-- <div class="footer-right-text">
          <div class="narrow">网 址</div>
          <div>www.jsfuan.com</div>
        </div> -->
      </div>
    </div>
    <div class="footer-text" @click="handleJump">
      桂ICP备2024047035号-1 Copyright ©广西华之茂投资集团有限公司 版权所有
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      midList: [
        {
          name: '关于我们',
          appCode: 'about',
        },
        // {
        //   name: '新闻中心'
        // },
        {
          name: '项目展示',
          appCode: 'news',
        },
        // {
        //   name: '招标信息'
        // },
        {
          name: '联系我们',
          appCode: 'callMe',
        }
      ]
    }
  },
  mounted () {},
  methods: {
    toPage(name) {
      this.$router.push({ name })
    },
    handleJump() {
      window.open('https://beian.miit.gov.cn/', '_blank');
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-box {
  width: 100%;
  background: #585858;
  .footer-information {
    display: flex;
    justify-content: space-around;
    height: 230px;
    .footer-left {
      .footer-logo {
        height: 54px;
        border-radius: 0 0 10px 10px;
      }
      .footer-title {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 20px;
        color: #ffffff;
        margin: 24px 0;
      }
      .footer-left-text {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        margin-bottom: 20px;
      }
    }
    .footer-mid {
      // flex: 1;
      padding-top: 60px;
      .mid-item {
        margin-bottom: 15px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 15px;
        color: #ffffff;
        cursor: pointer;
      }
    }
    .footer-right {
      padding-top: 60px;
      .footer-right-text {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 20px;
        color: #FFFFFF;
        margin-bottom: 24px;
        .narrow {
          font-size: 12px;
          zoom: .9;
        }
      }
    }
  }
  .footer-text {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    background: #2f2f2f;
    font-family: Arial;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    cursor: pointer;
  }
}
</style>
